import { t } from 'ember-intl';
import TasCommentsContent, { AddCommentForm } from 'tio-common/components/tas/comments/content';
import { DrawerHeader, DrawerBody, DrawerFooter } from 'tio-ui/components/drawer';
import type { TOC } from '@ember/component/template-only';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { PersonExtension as PersonModel } from 'tio-data/data/resources/person.ext';
import type { UserExtension as UserModel } from 'tio-data/data/resources/user.ext';

interface ManageCommentsDrawerSignature {
  Args: {
    application: TasApplicationModel;
    authoredByPerson: PersonModel;
    authoredByUser?: UserModel;
  };
}

/**
 * Comments drawer for the employee "manage" screen. Reuses the same
 * TasCommentsContent/AddCommentForm engine as the admin approval-page drawer
 * (`tas/approval/drawers/comments.gts`), but with `@showApproverTab={{false}}`
 * — approver-tagged comments are internal review notes and must never be
 * shown to the employee. New comments the employee posts are tagged
 * "employee", matching `employeeComments`'s filter in content.gts.
 */
const ManageCommentsDrawer: TOC<ManageCommentsDrawerSignature> = <template>
  <div class="tio-col-flush h-full">
    <DrawerHeader>
      <h2 class="tio-text-heading tio-fg-primary">
        {{t "tuition_assistance.applications.manage.action_toolbar.comments"}}
      </h2>
    </DrawerHeader>
    <DrawerBody>
      <TasCommentsContent
        @commentable={{@application}}
        @commentableType="TasApplication"
        @authoredByPerson={{@authoredByPerson}}
        @authoredByUser={{@authoredByUser}}
        @commentTags={{array "employee"}}
        @hideAddCommentForm={{true}}
        @initialTab="employee"
        @showApproverTab={{false}}
      />
    </DrawerBody>
    <DrawerFooter>
      <AddCommentForm
        @commentable={{@application}}
        @commentableType="TasApplication"
        @authoredByPerson={{@authoredByPerson}}
        @commentTags={{array "employee"}}
        @inDrawer={{true}}
      />
    </DrawerFooter>
  </div>
</template>;

export default ManageCommentsDrawer;
